// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadProducts,
    LoadRecentlyViewed,
    LoadRecommendedProducts,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";

const XngLoadBrandProductsLines = (props: any) => {
    if (props.parameter.carouselType === "brandProductLine") {
        props.getProductCollectionParameter = {
            pageSize: props.parameter.numberOfProductsToDisplay,
        };
        props.getProductCollectionParameter.excludeProductId = [props.parameter.productId];
        props.getProductCollectionParameter.productLineIds = [props.parameter.productLineId];
    }
};
const XngSetIsLoading = (props: any) => {
    props.dispatch({
        type: "xProductList/ProductCarousel/SetIsLoading",
        isLoading: true,
    });
};

addToChainAfter(chain, LoadRecommendedProducts, XngLoadBrandProductsLines);
addToChainBefore(chain, LoadRecentlyViewed, XngSetIsLoading);
